export default __webpack_public_path__ + "static/media/icon_tooltip.bc5674b6.svg";